module.exports = "<div class=\"input-form input-text date\">\r\n    <p-calendar (click)=\"lanzar($event)\" [(ngModel)]=\"date\" name=\"fecha\" [maxDate]=\"maxDate\" dateFormat=\"dd/MM/yy\" [locale]=\"es\" showButtonBar=\"true\" readonlyInput=\"true\" required></p-calendar>    \r\n    <span class=\"highlight\"></span>\r\n    <span class=\"bar\"></span>\r\n    <label *ngIf=\"date === null || date === undefined\" for=\"fecha\">Fecha</label>\r\n </div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/Components/calendario.component.html
// module id = ../../../../../src/app/home/Components/calendario.component.html
// module chunks = main